import { React, useRef, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import UserPhoto from "../../Assets/userphoto.png";
import { CircularProgress, TextField, Typography } from "@mui/material";
import Facebook from "../../Assets/Svg/Facebook.svg";
import Instagram from "../../Assets/Svg/instagram.svg";
import Telegram from "../../Assets/Svg/Telegram.svg";
import Whatsaap from "../../Assets/Svg/whatsaap.svg";
import { Helper } from "../../tools/Helper";
import { api_Routes } from "../../api_Routes";
import Files from "react-files";
import { useNavigate } from "react-router-dom";
import MainLoader from "../common/main-loader";
import { useDispatch, useSelector } from "react-redux";
import { setIsLoading, setProfileData } from "../../store/slices/profileSlice";
import ProfileHeader from "./profile-parts/header";
import EditCard from "./profile-parts/edit-card";
import EditForm from "./profile-parts/edit-form";

const Profile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const profileData = useSelector((state) => state.profile.profileData);
  const [editedProfile, setEditedProfile] = useState({
    ...profileData,
    photoPreview: null,
  });
  const isProfileDataLoading = useSelector((state) => state.profile.isLoading);
  const [isEditLoading, setIsEditLoading] = useState(false);

  const [isEditing, setIsEditing] = useState(false);
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    getCountries();
    if (profileData) {
      setEditedProfile({
        ...profileData,
        photoPreview: null,
      });
    }
  }, [profileData]);
  const handleEdit = async () => {
    const formData = new FormData();
    // Add all fields from editedProfile except photoPreview and photo
    Object.keys(editedProfile).forEach((key) => {
      if (
        key !== "photo" &&
        key !== "photoPreview" &&
        // key !== "sex" &&
        key !== "description" &&
        editedProfile[key]?.length !== 0
      ) {
        formData.append(key, editedProfile[key]);
      } else if (editedProfile[key]?.length === 0) {
        formData.append(key, "null");
      }
    });
    // Append only the binary file for photo
    if (selectedPhoto) {
      formData.append("photo", selectedPhoto); // Only the binary file
    }
    setIsEditLoading(true);
    const { response, message } = await Helper.Post({
      url: api_Routes.profile.updateprofile,
      hasToken: true,
      data: formData,
    });

    if (response) {
      dispatch(
        setProfileData({
          id: response.user.id,
          name: response.user.name,
          email: response.user.email,
          photo: "https://booksmmapi.rentchicken.net" + response.user.photo,
          description: response.user.description,
          whatsapp: response.user.whatsapp,
          telegram: response.user.telegram,
          instagram: response.user.instagram,
          facebook: response.user.facebook,
          tiktok: response.user.tiktok,
          skype: response.user.skype,
          sex: response.user.sex,
          about: response.user.about,
          country: response.user.country,
        })
      );
      setSelectedPhoto(null);
      setIsEditing(false);
    } else {
      console.error(message);
    }
    dispatch(setIsLoading());
    setIsEditLoading(false);
  };

  const handleCancel = () => {
    setSelectedPhoto(null);
    setIsEditing(false);
  };

  const handleInputChange = (field, value) => {
    console.log(field);
    setEditedProfile((prev) => ({
      ...prev,
      [field]: value,
    }));
    console.log(editedProfile);
  };

  const handleFileChange = (files) => {
    if (files && files.length > 0) {
      const file = files[0];
      setSelectedPhoto(file);
      setEditedProfile((prev) => ({
        ...prev,
        photoPreview: URL.createObjectURL(file),
      }));
    }
  };

  const handleFileError = (error) => {
    console.error("File upload error:", error);
  };

  const getCountries = () => {
    Helper.Get({
      url: api_Routes.Countries.view,
      hasToken: true,
      data: {
        results: 190,
      },
    }).then(({ response, message }) => {
      if (response) {
        setCountries(response);
      } else {
        console.error("Failed to fetch Countries data:", message);
      }
      setIsLoading(false); // Stop loading
    });
  };
  useEffect(() => {
    getCountries();
  }, []);
  return (
    <>
      {isProfileDataLoading ? (
        <MainLoader />
      ) : (
        <>
          <ProfileHeader
            isEditing={isEditing}
            handleFileChange={handleFileChange}
            handleFileError={handleFileError}
            editedProfile={editedProfile}
          />
          <EditCard
            editedProfile={editedProfile}
            isEditing={isEditing}
            handleEdit={handleEdit}
            isEditLoading={isEditLoading}
            setIsEditing={setIsEditing}
          />
          <EditForm
            countries={countries}
            isEditing={isEditing}
            handleInputChange={handleInputChange}
            editedProfile={editedProfile}
          />

        </>
      )}
    </>
  );
};
export default Profile;
